import localesJson from './locales.json';

export const LOCALES = localesJson;
